<template>
  <div class="msgDetails">
    <div style="display: flex; justify-content: space-between">
      <div class="zMsgSearch">
        <span>{{$t('common.dateRange')}}</span>
        <el-date-picker
          size="small"
          v-model="DataValue"
          type="datetimerange"
          :clearable="false"
          value-format="yyyy-MM-dd HH:mm:ss"
          :range-separator="$t('common.to')"
          :start-placeholder="$t('common.starDate')"
          :end-placeholder="$t('common.endDate')"
        >
        </el-date-picker>
        <span style="margin-left: 10px">{{$t('BatteryStatus.chargeAndDischarge')}}</span>
        <el-select
          v-model="chargeType"
          :placeholder="$t('common.choseTip')"
          class="searchSelect"
        >
          <el-option :label="$t('common.all')" value=""></el-option>
          <el-option :label="$t('BatteryStatus.charge')" value="0"></el-option>
          <el-option :label="$t('BatteryStatus.discharge')" value="1"></el-option>
        </el-select>
        <span style="margin-left: 10px">{{$t('BatteryStatus.isWarning')}}</span>
        <el-select
          v-model="isWarning"
          :placeholder="$t('common.choseTip')"
          class="searchSelect"
        >
          <el-option :label="$t('common.all')" value=""></el-option>
          <el-option :label="$t('common.normal')" value="0"></el-option>
          <el-option :label="$t('BatteryStatus.trouble')" value="1"></el-option>
        </el-select>
        <el-button
          style="margin-left: 18px"
          @click="onSearch"
          size="small"
          type="primary"
          class="btn-chaxun"
          >{{$t('common.btn.search')}}</el-button
        >
        <el-button @click="onClear" size="small" class="btn-del"
          >{{$t('common.btn.cancel')}}</el-button
        >
      </div>
      <el-button @click="down" size="small" type="text" style="font-size: 14px"
        >{{$t('common.btn.download')}}</el-button
      >
    </div>
    <div class="zMsgTable">
      <i-table
        :list="list"
        :height="height"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import iTable from "../../../../../src/components/Table.vue";
import IPagination from "../../../../../src/components/pagination.vue";
import { domainName } from "../../../../utility/index";
import moment from 'moment';
export default {
  props: ["bindBattery"],
  components: {
    iTable,
    IPagination,
  },
  data() {
    return {
      DataValue: [],
      chargeType: "",
      isWarning: "",
      height: "350",
      list: [], 
      option: {
        stripe: true, 
        border: true,
        loading: false, 
        highlightCurrentRow: false, 
        mutiSelect: false, 
        serialNumber: true, 
      },
      columns: [
        {
          prop: "happenTime",
          label: this.$t('BatteryStatus.happenTime'),
          align: "center",
          width: "180",
        },
        {
          prop: "endTime",
          label: this.$t('BatteryStatus.endTime'),
          align: "center",
          width: "180",
        },
        {
          prop: "happenElectricity",
          label: this.$t('BatteryStatus.happenElectricity'),
          align: "center",
          width: "120",
        },
        {
          prop: "endElectricity",
          label: this.$t('BatteryStatus.endElectricity'),
          align: "center",
          width: "120",
        },
        {
          prop: "continuedTime",
          label: this.$t('BatteryStatus.continuedTime'),
          align: "center",
          width: "120",
        },
        {
          prop: "judgeRate",
          label: this.$t('BatteryStatus.judgeRate'),
          align: "center",
        },
        {
          prop: "rate",
          label: this.$t('BatteryStatus.rate'),
          align: "center",
        },
        {
          prop: "isWarning",
          label: this.$t('BatteryStatus.isWarning'),
          align: "center",
          render: (h, params) => {
            return h(
              "el-tag",
              {
                props: {
                  type:
                    params.row.isWarning == null
                      ? ""
                      : params.row.isWarning == 0
                      ? "success"
                      : "danger",
                },
              },
              params.row.isWarning == null
                ? ""
                : params.row.isWarning == 0
                ? this.$t('common.normal')
                : this.$t('common.abnormal')
            );
          },
        },
        {
          prop: "chargeType",
          label: this.$t('BatteryStatus.chargeType'),
          align: "center",
          render: (h, params) => {
            return h(
              "el-tag",
              {
                props: {
                  type:
                    params.row.chargeType == null
                      ? ""
                      : params.row.chargeType == 0
                      ? "success"
                      : "danger",
                },
              },
              params.row.chargeType == null
                ? ""
                : params.row.chargeType == 0
                ? this.$t('BatteryStatus.charge')
                : this.$t('BatteryStatus.discharge')
            );
          },
        },
      ],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      },
      currentPage: 1, 
      pageSize: 10, 
      total: 1, 
      bindValue: "",
    };
  },
  created() {
    this.getDate()
  },
  methods: {
    getDate() {
      const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      const startTime = moment().startOf("month").format("YYYY-MM-DD HH:mm:ss");
      this.DataValue = [startTime, endTime];
    },
    getCarRealTime() {
      let startTime = "";
      let endTime = "";
      if (this.DataValue) {
        if (this.DataValue.length > 0) {
          startTime = this.DataValue[0];
          endTime = this.DataValue[1];
        }
      }
      let param = {
        batteryNumber: this.bindBattery,
        chargeType: this.chargeType,
        isWarning: this.isWarning,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$store
        .dispatch("BatteryFile/GET_QUERYBATTERYCHARGEINFO", param)
        .then((res) => {
          if (res) {
            console.log(res);
            if (res.data.code == 200) {
              this.list = res.data.data.list;
              this.$refs.page.CommandTotal = res.data.data.total;
            }
          }
        })
        .catch((err) => {});
    },
    onSearch() {
      this.$refs.page.CommandCurrentPage = 1
      this.currentPage = 1
      this.getCarRealTime();
    },
    onClear() {
      this.getDate()
      this.chargeType = "";
      this.isWarning = "";
      this.getCarRealTime();
    },
    down() {
      if (domainName) {
        if (domainName.split(":")[0] !== "localhost") {
          let startTime = "";
          let endTime = "";
          if (this.DataValue) {
            if (this.DataValue.length > 0) {
              startTime = this.DataValue[0];
              endTime = this.DataValue[1];
            }
          }
          let url = `https://${domainName}/v1/getExportExcel/uploadBatteryUse?batteryNumber=${this.bindBattery}&chargeType=${this.chargeType}&isWarning=${this.isWarning}&startTime=${startTime}&endTime=${endTime}`;
          location.href = url;
        } else {
          let host = "localhost:8080";
          let url = `https://${host}/v1/getExportExcel/uploadBatteryUse?batteryNumber=${this.bindBattery}&chargeType=${this.chargeType}&isWarning=${this.isWarning}&startTime=${startTime}&endTime=${endTime}`;
          location.href = url;
        }
      }
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    changeSize(item) {
      this.pageSize = item.pageSize;
      this.currentPage = item.pageNum;
      this.getCarRealTime();
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
